// extracted by mini-css-extract-plugin
var _1 = "EditorThread_root__1a7ec";
var _2 = "EditorThread_title__68f28";
export { _1 as "root", _2 as "title" }
